module.exports = __webpack_public_path__ + "img/122.015d2fe9.png";